import { toast } from "react-toastify";
import {
  isApiAlertActive,
  isTokenInvalidText,
  shouldTreatHttpFailureAsSessionExpired,
  showSessionExpiredAlert,
} from "./apiAlert";

const normalizeToastMessage = (message) => {
  if (message == null) return "";
  return typeof message === "string" ? message.trim() : String(message).trim();
};

const shouldShowSessionExpired = (message) => {
  const text = normalizeToastMessage(message);
  if (!text) return false;
  if (isTokenInvalidText(text)) return true;
  return /session expired/i.test(text);
};

const requestHasAuthHeader = (init) => {
  const headers = init?.headers;
  if (!headers) return false;
  if (headers instanceof Headers) {
    return Boolean(headers.get("Authorization") || headers.get("authorization"));
  }
  if (Array.isArray(headers)) {
    return headers.some(
      ([key, value]) =>
        String(key).toLowerCase() === "authorization" && Boolean(value)
    );
  }
  return Boolean(headers.Authorization || headers.authorization);
};

export const installSessionToastInterceptor = () => {
  if (toast.error.__sessionInterceptorInstalled) return;

  const originalError = toast.error.bind(toast);
  toast.error = (message, options) => {
    const text = normalizeToastMessage(message);
    if (!text) return;
    if (isApiAlertActive()) return;

    if (shouldShowSessionExpired(message)) {
      showSessionExpiredAlert();
      return;
    }
    return originalError(message, options);
  };

  toast.error.__sessionInterceptorInstalled = true;
};

export const installFetchSessionInterceptor = () => {
  if (typeof window === "undefined" || window.__fetchSessionInterceptorInstalled) return;

  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    const response = await originalFetch(input, init);

    if (
      requestHasAuthHeader(init) &&
      [401, 403].includes(response.status)
    ) {
      let body = null;
      try {
        const text = await response.clone().text();
        if (text) {
          try {
            body = JSON.parse(text);
          } catch {
            body = { message: text };
          }
        }
      } catch {
        /* ignore parse errors */
      }

      if (shouldTreatHttpFailureAsSessionExpired(response.status, body)) {
        showSessionExpiredAlert();
      }
    }

    return response;
  };

  window.__fetchSessionInterceptorInstalled = true;
};

export const installSessionInterceptors = () => {
  installSessionToastInterceptor();
  installFetchSessionInterceptor();
};
